import { getRoofZoneNumberFromClassification } from '__editor/panelsEditor/components/roofZones/roofZoneNumbers';
import { calculateRmZonesMessageResult } from '../../../../../../workers/shared/message';
import { isRMDT } from '../../../../../../workers/common/products';

export const applyClassificationToPanels = (
  panels: panelInState[],
  productId: number,
  classification: NonNullable<calculateRmZonesMessageResult['classification']>,
) => {
  const siblingById = new Map<number, panelInState>();
  if (isRMDT(productId)) {
    const siblingsBySiblingId = new Map<number, panelInState[]>();
    panels.forEach((panel) => {
      if (panel.siblingId === undefined || panel.siblingId === null || panel.siblingId <= 0) {
        return;
      }
      const siblings = siblingsBySiblingId.get(panel.siblingId) || [];
      siblings.push(panel);
      siblingsBySiblingId.set(panel.siblingId, siblings);
    });
    siblingsBySiblingId.forEach((siblings) => {
      if (siblings.length !== 2) {
        return;
      }
      siblingById.set(siblings[0].id, siblings[1]);
      siblingById.set(siblings[1].id, siblings[0]);
    });
  }

  // Keep every panel, even when the worker misses an id. Building-code change
  // and project load replace the roof array with this result
  // (REPLACE_PANELS_ON_ROOF). Dropping unclassified panels there deletes them
  // from the design. Editor UPDATE_PANELS merges by id, so a miss already
  // leaves existing zone colors in place.
  return panels.map((panel) => {
    const panelClassification = classification[panel.id];
    if (panelClassification) {
      return {
        ...panel,
        roofZone: getRoofZoneNumberFromClassification(panelClassification),
      };
    }

    const sibling = siblingById.get(panel.id);
    if (sibling && classification[sibling.id]) {
      return {
        ...panel,
        roofZone: getRoofZoneNumberFromClassification(classification[sibling.id]),
      };
    }

    return panel;
  });
};
